import type { AtlasPerson } from './family-atlas.js';
import { discendenti, parentTitle, pedigree, type Nodo, type ParentSide } from '../../shared/albero.js';


/** Un posto nei «Rami familiari» e nell'albero: la persona è quella completa dell'atlante. */
export type Ancestor = Nodo<AtlasPerson>;
export { discendenti, parentTitle, pedigree, type ParentSide };

export const PEDIGREE_W = 214, PEDIGREE_H = 200, PEDIGREE_GAP = 28, PEDIGREE_ROW = 252;
/** Radice in basso, padre a sinistra e madre a destra a OGNI biforcazione.
 * Le posizioni dipendono dai percorsi genealogici, mai dal gruppo manuale. */
export function pedigreeLayout(tree: Ancestor) {
  const nodes: Ancestor[] = [], spans = new Map<string, number>(), positions = new Map<string, { x: number; y: number }>();
  let levels = 0;
  const measure = (node: Ancestor): number => {
    nodes.push(node); levels = Math.max(levels, node.level);
    const span = node.parents.length ? node.parents.reduce((sum, p) => sum + measure(p), 0) : PEDIGREE_W + PEDIGREE_GAP;
    spans.set(node.key, span); return span;
  };
  const width = Math.max(520, measure(tree) + 48), height = (levels + 1) * PEDIGREE_ROW + 24;
  const place = (node: Ancestor, left: number): void => {
    const span = spans.get(node.key)!;
    positions.set(node.key, { x: left + (span - PEDIGREE_W) / 2, y: (levels - node.level) * PEDIGREE_ROW + 44 });
    for (const parent of node.parents) { place(parent, left); left += spans.get(parent.key)!; }
  };
  place(tree, (width - spans.get(tree.key)!) / 2);
  return { nodes, positions, width, height };
}
